<template>
    <nav class="main-menu">
        <!-- navigation links -->
        <b-tooltip
            v-for="item in items"
            :key="item.title"
            type="is-info"
            class="menu-tooltip-wrap"
            :label="item.title"
            position="is-right"
            @click.native="clickEvent(item.title)"
        >
            <router-link
                class="nav-link has-cursor-pointer"
                tag="div"
                exact-path
                :to="item.link"
            >
                <component
                    :is="item.icon"
                    class="menu-icon"
                />
                <div class="selected-marker" />
            </router-link>
        </b-tooltip>

        <div class="spacer" />

        <!-- user controls -->
        <slot name="user-controls" />
    </nav>
</template>

<script>
export default {
    props: {
        // list of items shown in the nav
        items: {
            type: Array,
            required: true,
        },
    },

    methods: {
        /**
         * Triggers a tracking event when the menu nav is clicked
         * @param {String} clickedItem menu nav option user has selected
         */
        clickEvent(clickedItem) {
            if (this.$ga) {
                this.$ga.event('Navigation', 'nav-click', clickedItem);
            }
        },
    },
};
</script>

<style lang="scss">

nav.main-menu {
    // bulma variables
    $primary: #33284a !default;
    $primary-invert: #9492a3 !default;
    $primary-dark: #1e1436 !default;
    $primary-dark-invert: #fff !default;
    $secondary: #3195f7 !default;
    $main-nav-width: 3rem !default;
    $white: #fff !default;

    background: $primary;
    color: $primary-invert;
    display: flex;
    flex-direction: column;

    &.full-height {
        height: 100vh;
    }

    .spacer {
        flex: 1 1;
        min-height: 1em;
    }

    .nav-link {
        flex: 0 0;
        height: $main-nav-width;
        width: $main-nav-width;
        flex-basis: $main-nav-width;
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            fill: $primary-invert;
        }

        &:hover {
            background: $primary-dark;
            border-color: $primary-invert transparent;

            svg {
                fill: $primary-dark-invert;
            }
        }

        .selected-marker {
            $selected-marker-height: 68%;

            margin: ((100% - $selected-marker-height) / 2) 0;
            background: $secondary;
            height: $selected-marker-height;
            left: 0;
            position: absolute;
            top: 0;
            width: 5px;
            border-radius: 0 5px 5px 0;
            transition: opacity 0.15s;
            opacity: 0;
        }

        &.router-link-exact-active {
            .selected-marker {
                opacity: 1;
            }

            svg {
                fill: $white;
            }
        }
    }

    .menu-tooltip-wrap {
        display: block;
    }
}
</style>
